<template>
  <div class="supplier-brand" v-show="brands.length">
     <!-- <div class="title">{{title}}</div> -->
    <div class="brand-list">
      <button
        class="brand"
        v-for="({configer}, index) in brands"
        :key="index"
        @click="jump(configer)"
      >
        <div class="brand-img">
           <img v-lazy="configer.img" alt />
        </div>
        <div class="brand-desc">
          <span class="tit">{{configer.title}}</span>
          <span class="sub-title">{{configer.subtitle}}</span>
        </div>
      </button>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'
export default {
  name: 'supplierBrands',
  props: {
    brands: {
      type: Array
    },
    title: {
      type: String,
      default: '权益合作伙伴'
    }
  },
  computed: {
    ...mapState('store', [
      'Authorization'
    ])
  },
  methods: {
    jump (arg) {
      if (arg.is_login) {
        if (this.Authorization) {
          if (arg.is_ajax) {
            this.jumpUrlHandler(arg.url)
          }
        } else {
          this.$router.push({ name: 'login' })
        }
      } else {
        if (arg.url) {
          // console.log(arg.url)
          location.href = arg.url
        } else {
          this.$toast('敬请期待')
        }
      }
    },
    async jumpUrlHandler (url) {
      const res = await this.$axios.get(url)
      if (res.status === 200) {
        const { code, msg, data } = res.data
        if (code === 0) {
          // console.log(data)
          window.location.href = data
        } else if (code === -1) {
          this.$router.push({ name: 'login' })
        } else {
          this.$toast(msg)
        }
      }
    }
  }
}
</script>

<style lang="less" scoped>
.supplier-brand {
  padding: 0 0.2rem 0.25rem;
  background-color: #fff;
  .title {
    font-size: @fz32;
    color: @base;
  }
  .brand {
    position: relative;
    width: 2.22rem;
    height: 2.77rem;
    // border: 0.5px solid #D5D5D5;
    margin-top: 0.3rem;
    border-radius: 0.14rem;
    &:nth-child(3n-1) {
      margin: 0.3rem 0.22rem 0;
    }
    .brand-img {
      width: 100%;
      height: 2.77rem;
      img {
        object-fit: contain;
      }
    }
    .brand-desc {
      position: absolute;
      left: 0;
      bottom: 0rem;
      width: 100%;
      height: 1.02rem;
      font-size: @fz24;
      z-index: 9;
      .flex-column-center;
      color: #fff;
      span:nth-child(1) {
        padding-top: 0.2rem;
      }
      .title {
      }
      .sub-title {
        padding-top: 0.06rem;
      }
    }
  }
}
</style>
